import request from '../services/request';

const TIME_OUT = 120_000; // 2 minutes

export function availableVersions() {
  return request({
    url: `/company/setup/version`,
    method: 'GET',
    timeout: TIME_OUT,
  });
}

export function availableLevels() {
  return request({
    url: `/company/setup/levels`,
    method: 'GET',
    timeout: TIME_OUT,
  });
}

export function availableMongoConnections() {
  return request({
    url: `/company/setup/mongodb/connection`,
    method: 'GET',
    timeout: TIME_OUT,
  });
}

export function availablePleskConnections() {
  return request({
    url: `/company/setup/plesk/connection`,
    method: 'GET',
    timeout: TIME_OUT,
  });
}

// ----- Registrar compania ----
export function createMainDomain(data) {
  return request({
    url: `/company/setup/manager`,
    method: 'POST',
    data,
    timeout: TIME_OUT,
  });
}

// ----- Plesk -------------
export function createMainDomainSSL(id, data) {
  return request({
    url: `/company/setup/${id}/manager/ssl`,
    method: 'POST',
    data,
    timeout: TIME_OUT,
  });
}

export function createApiSubDomain(id) {
  return request({
    url: `/company/setup/${id}/api`,
    method: 'POST',
    timeout: TIME_OUT,
  });
}

export function createApiSubDomainSSL(id, data) {
  return request({
    url: `/company/setup/${id}/api/ssl`,
    method: 'POST',
    data,
    timeout: TIME_OUT,
  });
}

export function createNotifySubDomain(id) {
  return request({
    url: `/company/setup/${id}/notify`,
    method: 'POST',
    timeout: TIME_OUT,
  });
}

export function createNotifySubDomainSSL(id, data) {
  return request({
    url: `/company/setup/${id}/notify/ssl`,
    method: 'POST',
    data,
    timeout: TIME_OUT,
  });
}

export function createTerminalsSubDomain(id) {
  return request({
    url: `/company/setup/${id}/terminals`,
    method: 'POST',
    timeout: TIME_OUT,
  });
}

export function createTerminalsSubDomainSSL(id, data) {
  return request({
    url: `/company/setup/${id}/terminals/ssl`,
    method: 'POST',
    data,
    timeout: TIME_OUT,
  });
}

export function createMongoDbService(id, data) {
  return request({
    url: `/company/setup/${id}/database/mongodb`,
    method: 'POST',
    data,
    timeout: TIME_OUT,
  });
}

// ------ Instalaciones -----
export function createApiRepository(id, data) {
  return request({
    url: `/company/setup/${id}/git/create/api`,
    method: 'POST',
    data,
    timeout: TIME_OUT,
  });
}

export function createApiTag(id, data) {
  return request({
    url: `/company/setup/${id}/git/tag/api`,
    method: 'POST',
    data,
    timeout: TIME_OUT,
  });
}

// -------- Laravel ---------------------------
export function laravelInstall(id) {
  return request({
    url: `/company/setup/${id}/laravel/install`,
    method: 'POST',
    timeout: TIME_OUT,
  });
}

export function laravelAdmin(id, data) {
  return request({
    url: `/company/setup/${id}/laravel/admin`,
    method: 'POST',
    data,
    timeout: TIME_OUT,
  });
}

export function laravelToken(id) {
  return request({
    url: `/company/setup/${id}/laravel/token`,
    method: 'POST',
    timeout: TIME_OUT,
  });
}

export function laravelSynchronize(id) {
  return request({
    url: `/company/setup/${id}/laravel/synchronize`,
    method: 'POST',
    timeout: TIME_OUT,
  });
}

export function laravelSeeds(id) {
  return request({
    url: `/company/setup/${id}/laravel/seeds`,
    method: 'POST',
    timeout: TIME_OUT * 2, // 4 minutes
  });
}

export function notifyInstall(id) {
  return request({
    url: `/company/setup/${id}/notify/install`,
    method: 'POST',
    timeout: TIME_OUT,
  });
}

export function terminalsInstall(id) {
  return request({
    url: `/company/setup/${id}/terminals/install`,
    method: 'POST',
    timeout: TIME_OUT,
  });
}

export function managerInstall(id) {
  return request({
    url: `/company/setup/${id}/manager/install`,
    method: 'POST',
    timeout: TIME_OUT,
  });
}

export function faceprintServerInstall(id) {
  return request({
    url: `/company/setup/${id}/face-server/install`,
    method: 'POST',
    timeout: TIME_OUT,
  });
}

export function fingerprintServerInstall(id) {
  return request({
    url: `/company/setup/${id}/fingerprint-server/install`,
    method: 'POST',
    timeout: TIME_OUT,
  });
}

export function mqttAcl(id) {
  return request({
    url: `/company/setup/${id}/acl/mqtt`,
    method: 'POST',
    timeout: TIME_OUT,
  });
}

export function redisAcl(id) {
  return request({
    url: `/company/setup/${id}/acl/redis`,
    method: 'POST',
    timeout: TIME_OUT,
  });
}

export function startup(id) {
  return request({
    url: `/company/setup/${id}/service/startup`,
    method: 'POST',
    timeout: TIME_OUT,
  });
}
